import {
    grayColor, breakPoints
} from "assets/jss/material-dashboard-react.js";

const sm = "@media (min-width: " + breakPoints.sm + ")";

const customImageInputStyle = theme => ({
    hidden: { display: "none" },

    container: {
        margin: "auto"
    },
    title: {
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        padding: theme.spacing(1)
    },
    bigAvatar: {
        margin: "auto",
        width: 200,
        height: 100,
        borderColor: grayColor[1],
        borderStyle: "solid",
        borderWidth: "1px",
        color: "gray"
    },
    avatarThumb: {
        maxWidth: 300,
        maxHeight: 150
    },
    primaryBack: {
        background: "white"
    },
    whiteBack: {
        background: "white"
    },
    [sm]: {
        bigAvatar: {
            width: 300,
            height: 150
        }
    },
    errorBack: { background: theme.palette.error.main }
});
export default customImageInputStyle;
